import { Route } from 'react-router-dom';

import RequirePermission from '../../shared/RequirePermission';
import { Permission } from '../../types/permissions';

import GiftPassDetailPage from './GiftPassDetailPage';
import GiftPassesListPage from './GiftPassesListPage';

export const giftPassesRoutes = (
  <>
    <Route
      path="gift-passes"
      element={
        <RequirePermission permission={Permission.READ_GIFT_PASSES}>
          <GiftPassesListPage />
        </RequirePermission>
      }
    />
    <Route
      path="gift-passes/:id"
      element={
        <RequirePermission permission={Permission.READ_GIFT_PASSES}>
          <GiftPassDetailPage />
        </RequirePermission>
      }
    />
  </>
);
